
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnfoldLessGoogle as ObiUnfoldLessGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-unfold-less-google.js';
 
 
 

 
 export const ObiUnfoldLessGoogle = createComponent({
   react: React,
   tagName: 'obi-unfold-less-google',
   elementClass: ObiUnfoldLessGoogleElement,
   events: {
     
   }
  });
 
 